import { render, staticRenderFns } from "./ClientBasicInfo.vue?vue&type=template&id=456400e7"
import script from "./ClientBasicInfo.vue?vue&type=script&lang=js"
export * from "./ClientBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./ClientBasicInfo.vue?vue&type=style&index=0&id=456400e7&prod&lang=css"
import style1 from "./ClientBasicInfo.vue?vue&type=style&index=1&id=456400e7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports